import React, {useEffect, useState} from 'react'
import {PageWrap} from "../../Components";
import {Button, Descriptions, Input, message, Result} from "antd";
import {REPO} from "../../Repository/repo";
import {EnvModel} from "../../Model/Common";
import {onConfirm} from "../../Helper/Helper";
import useUser from "../../Hooks/useUser";

const EnviromentPage = () => {
    const [data, setData] = useState<EnvModel[]>([])
    const {userData} = useUser()
    const isAdmin = !!userData?.data?.is_admin

    useEffect(()=>{
        if (!isAdmin) return
        fetchMethod()
    },[isAdmin])

    const fetchMethod = async () => {
        try {
            const result = await REPO.System.Env()
            setData(result.data.env)
        } catch (e) {

        }
    }

    const onChangeHandler = (name:string, value:string) => {
        setData(data.map((info, k) => {
            if(info.env_name === name){
                info.env_value = value
            }

            return info
        }))
    }

    const submitHandler = () => {
        onConfirm("확인", "환경설정을 저장하시겠습니까?", async ()=>{
            try {
                const result = await REPO.System.EnvSave(data)
                message.success("저장되었습니다.")
            } catch (e) {

            }
        })
    }

    if (!isAdmin) {
        return (
            <PageWrap>
                <Result status={"403"} title={"403"} subTitle={"접근 권한이 없습니다."}/>
            </PageWrap>
        )
    }

    return (
        <PageWrap>
            <h3>환경설정</h3>
            <Descriptions column={1} bordered>
                {data.map((info,key) => (
                    <Descriptions.Item label={info.env_name} key={key}>
                        <Input onChange={(e)=>onChangeHandler(info.env_name, e.target.value)} value={info.env_value}/>
                    </Descriptions.Item>
                ))}
            </Descriptions>
            <div style={{textAlign: "right"}}>
                <Button type={"primary"} onClick={submitHandler}>저장</Button>
            </div>
        </PageWrap>
    )
}

export default EnviromentPage